import moment from 'moment';

const formatDate = (date) => {
  const formattedDate = moment(date).format('DD/MM/YYYY - HH[h]mm');
  return formattedDate;
};

const formatDateOnly = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

export {
  formatDate,
  formatDateOnly
}
